var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissingRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "missing_red",
    transform: "translate(-516 -287)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11605",
    "data-name": "Rectangle 11605",
    width: 24,
    height: 24,
    transform: "translate(516 287)",
    fill: "#f64f64",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "warning_black_24dp",
    d: "M4.358,19.993h14.22a1.881,1.881,0,0,0,1.634-2.822L13.1,4.931a1.891,1.891,0,0,0-3.267,0L2.725,17.17a1.881,1.881,0,0,0,1.634,2.822Zm7.11-6.585a.945.945,0,0,1-.944-.941V10.585a.944.944,0,0,1,1.889,0v1.882A.945.945,0,0,1,11.469,13.407Zm.944,3.763H10.524V15.289h1.889Z",
    transform: "translate(516.531 287.008)",
    fill: "#f64f64"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingRed);
export default __webpack_public_path__ + "static/media/missing_red.6c0aab9efb14cb7224b85ae01bd99cc0.svg";
export { ForwardRef as ReactComponent };